import React from "react";
import { Button } from "antd";
import style from "./index.module.scss";
import classNames from "classnames";
import { workState } from "../../../../../API";

interface ItemLinkProps {
    status: workState;
    className: string;
    onClick: () => void;
}

export default function ItemLink({
    status,
    className,
    onClick
}: ItemLinkProps) {
    const btnTextMap: any = {
        [workState.HaveHomework]: "前往提交",
        [workState.Done]: "查看作业",
        [workState.NotMark]: "重新提交",
        [workState.Overtime]: "查看作业"
    };

    return (
        <Button
            type="link"
            onClick={onClick}
            className={classNames(style.root, className)}>
            {btnTextMap[status]}
        </Button>
    );
}
